import React from 'react'
import Modal from 'react-modal'
import { partition, prop } from 'ramda'
import { Link, navigate, graphql } from 'gatsby'
import Img from 'gatsby-image'
import Banner from '../components/banner'
import PersonModal from '../components/person-modal'
import ReactMarkdown from 'react-markdown'

const slug = (person) => person && person.node.slug

const findFocusPerson = (name, people) => {
  let focus, prev, next

  if (name) {
    people.some((node, idx) => {
      const person = node.node

      prev = slug(people[idx - 1])
      next = slug(people[idx + 1])

      if (name === person.slug) {
        focus = person
        return true
      }
    })
  }

  return [focus, prev, next]
}

const Person = ({ person }) => {
  const { first, last, title, slug, thumb } = person

  return (
    <div className="person">
      <Img fluid={thumb?.childImageSharp?.resolutions} alt={first} />
      <div className="name-title">
        <h3>
          {first} {last}
        </h3>
        <h4>{title}</h4>
      </div>
      <Link to={`/who/${slug}/`} alt={`${first} ${last}`}></Link>
    </div>
  )
}

const closeRequested = () => navigate('/who/')

const WhoPage = (props) => {
  const { data, subSlug, pathContext } = props
  const people = data.allStrapiTeamMember && data.allStrapiTeamMember.edges

  const focusName = subSlug || pathContext.slug

  const [focusPerson, prev, next] = findFocusPerson(focusName, people)
  const [partTime, fullTime] = partition(
    prop('part_time'),
    people.map(prop('node'))
  )

  return (
    <div>
      <Banner data={data.strapiWhoWeAre} credit="Tim Daw" />

      <div className="content-body">
        <h1>{data.strapiWhoWeAre.header_part.header}</h1>

        <ReactMarkdown>
          {data.strapiWhoWeAre.header_part.description}
        </ReactMarkdown>

        <div className="people">
          {fullTime.map((person) => (
            <Person person={person} key={person.first} />
          ))}
        </div>
        <h4>Part-Time</h4>
        <div className="people">
          {partTime.map((person) => (
            <Person person={person} key={person.first} />
          ))}
        </div>
      </div>

      <Modal
        isOpen={!!focusPerson}
        bodyOpenClassName="modal-open person-modal-open"
        portalClassName="modal person-modal"
        overlayClassName="modal-overlay"
        className="modal-body"
        onRequestClose={closeRequested}
      >
        {focusPerson && (
          <PersonModal person={focusPerson} next={next} prev={prev} />
        )}
      </Modal>
    </div>
  )
}

export const query = graphql`
  query WhoQuery {
    allStrapiTeamMember(sort: { order: [ASC, DESC], fields: [display_order, created_at] }) {
      edges {
        node {
          first
          last
          bio
          title
          slug
          twitter
          linkedin
          youtube
          medium
          reddit
          blog
          photocredit
          part_time
          thumb {
            childImageSharp {
              resolutions(width: 103, quality: 75) {
                ...GatsbyImageSharpResolutions
              }
            }
          }
          portrait {
            childImageSharp {
              fluid(maxWidth: 768, quality: 75) {
                ...GatsbyImageSharpFluid
                ...GatsbyImageSharpFluidLimitPresentationSize
              }
            }
          }
        }
      }
    }

    strapiWhoWeAre {
      header_part {
        header
        description
      }
      mobile_banner {
        ...MobileBannerSizes
      }
      desktop_banner {
        ...DesktopBannerSizes
      }
    }
  }
`

export default WhoPage
